export default class BfvEmailHandler {
  constructor(options = {}) {
    this.$root = options.element;
    this.apiName = this.$root.getAttribute('data-api');
    this.$textlink = this.$root.querySelectorAll('.js-bfv-contact__email-link')[0];
    this.$email = this.$root.querySelectorAll('.js-bfv-contact__replace-email');
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    if (this.$textlink) {
      this.$textlink.addEventListener('click', (event) => {
        event.preventDefault();
        this.showEmailAddressAndHideLink();
      });
    }
  }

  showEmailAddressAndHideLink() {
    if (this.apiName) {
      window.divae.restApi
        .loadData(this.apiName, 'application/xhtml+xml')
        .then((_response) => {
          this.$root.innerHTML = _response;
        })
        .catch(() => {
          console.error('Es ist keine E-Mail-Adresse hinterlegt');
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/javascript/main/BfvEmailHandler/index.js